import { Box, Button, IconButton, styled, Typography } from "@mui/material";

export const CollabTitle = styled(Typography)({
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.15px",
});
CollabTitle.defaultProps = { component: "span" };

export const CollabSectionTitle = styled(Typography)({
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.1px",
});
CollabSectionTitle.defaultProps = { component: "span" };

export const CollabText = styled(Typography)({
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "16px",
  letterSpacing: "0.5px",
});
CollabText.defaultProps = { component: "span" };

export const CollabHelperText = styled(Typography)({
  fontWeight: 400,
  fontSize: "11px",
  lineHeight: "16px",
  letterSpacing: "0.5px",
});
CollabHelperText.defaultProps = { component: "span" };

// Matches the input field label style (TextFieldCustomNew's `.label`) — used
// as a standalone heading above a block that isn't itself a form field, e.g.
// the "Μέλη" heading above the member rows in the Access & Members section.
export const CollabFieldLabel = styled(Typography)({
  fontWeight: 400,
  fontSize: "11px",
  lineHeight: "16px",
  letterSpacing: "0.5px",
  color: "#605e5e",
  // The parent's flex `gap` already adds 10px below this — same as every
  // other row spacer — so pull back to the 4px a field label keeps from its
  // own input (see TextFieldCustomNew's `.label` marginBottom).
  marginBottom: "-6px",
});
CollabFieldLabel.defaultProps = { component: "span" };

export const CollabIconButton = styled(IconButton)({
  width: "32px",
  height: "32px",
  backgroundColor: "rgba(247,247,247,0.7)",
  borderRadius: "10px",
  padding: 0,
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.10)",
  },
});
CollabIconButton.defaultProps = { size: "small" };

export const CollabBadgeCount = styled(Box)(() => ({
  width: "24px",
  minWidth: "24px",
  height: "18px",
  borderRadius: "12px",
  backgroundColor: "#d5433a",
  color: "#fff",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "1px 3px",
  flexShrink: 0,
}));

export const ButtonStyled = styled(Button)(({ theme }) => ({
  padding: "6px 12px",
  backgroundColor: "#81A6B329",
  color: "#002129",
  borderRadius: "10px",
  border: "1px solid #81A6B329",
  "&:hover": {
    backgroundColor: "#ffffff",
    border: `1px solid ${theme.palette.divider}`,
  },
  "&.Mui-disabled": {
    backgroundColor: "#f0f0f0",
    color: "#999",
  },
  "&.minimal": {
    backgroundColor: "white",
    border: `1px solid ${theme.palette.divider}`,
    "&:hover": { backgroundColor: "#f5f5f5" },
  },
}));

// New-design sibling of ButtonStyled (outlined or filled dark teal, not the mint default).
export const ButtonStyledNew = styled(Button, {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ variant = "outlined" }) => ({
  padding: "6px 12px",
  borderRadius: "10px",
  fontSize: "12px",
  letterSpacing: "0.4px",
  textTransform: "none",
  ...(variant === "filled"
    ? {
        backgroundColor: "#0e414d",
        color: "#fff",
        border: "1px solid #0e414d",
        "&:hover": { backgroundColor: "#0a323b" },
      }
    : variant === "danger"
      ? {
          backgroundColor: "#ffedea",
          color: "#ae2822",
          border: "1px solid #ffedea",
          "&:hover": { backgroundColor: "#ffe0da" },
        }
      : {
          backgroundColor: "#fff",
          color: "#002129",
          border: "1px solid rgba(116,120,121,0.16)",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }),
  "&.Mui-disabled": {
    backgroundColor: "#f0f0f0",
    color: "#999",
    border: "1px solid #f0f0f0",
  },
}));
